
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lGLcJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $93bf3b8566605294$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $93bf3b8566605294$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Team \u2022 50+ leden",
    'fabric.elements.mentions.team.member.50plus.including.you': "Team \u2022 50+ leden, inclusief jezelf.",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {Team \u2022 {0} lid} other {Team \u2022 {0} leden.}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {Team \u2022 {0} lid, inclusief jezelf} other {Team \u2022{0} leden, inclusief jezelf}}",
    'fabric.elements.mentions.xproduct.mention.description': 'Heeft toegang nodig tot Confluence',
    'fabric.mention.error.defaultAction': 'Probeer het over een paar seconden opnieuw',
    'fabric.mention.error.defaultHeadline': 'Er is iets misgegaan',
    'fabric.mention.error.differentText': 'Probeer het opnieuw met een andere tekst',
    'fabric.mention.error.loginAgain': 'Log uit en probeer dan opnieuw in te loggen',
    'fabric.mention.noAccess.label': 'Geen toegang',
    'fabric.mention.noAccess.warning': '{name} ontvangt geen melding omdat hij/zij geen toegang heeft',
    'fabric.mention.unknow.user.error': 'Onbekende gebruiker ({userId})'
};

});


//# sourceMappingURL=nl.7ba79509.js.map
